exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Chart_tableContainer_31k-S{overflow:auto}.Chart_tableContainer_31k-S table,.Chart_tableContainer_31k-S td,.Chart_tableContainer_31k-S th{border:1px solid #000;border-spacing:0;border-collapse:collapse}.Chart_footerButton_C2Cbf{display:inline-block;cursor:pointer;color:#549bd4;margin-left:20px;-webkit-transition:.2s;transition:.2s}.Chart_footerButton_C2Cbf:hover{color:#28608f}.Chart_switchWrapper_TU1f5{padding-bottom:10px}.Chart_root_1yP0m{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin:auto;border:1px solid #000;border-radius:10px}.Chart_button_3sgQz{display:block;width:50%;border-radius:10px;padding:5px 15px;color:#333;cursor:pointer}.Chart_active_1w_XD{color:#fff;background-color:#000}", ""]);

// exports
exports.locals = {
	"tableContainer": "Chart_tableContainer_31k-S",
	"footerButton": "Chart_footerButton_C2Cbf",
	"switchWrapper": "Chart_switchWrapper_TU1f5",
	"root": "Chart_root_1yP0m",
	"button": "Chart_button_3sgQz",
	"active": "Chart_active_1w_XD"
};